import Vue from 'vue'
import Vuetify from 'vuetify'
import VuetifyLib from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new VuetifyLib({
  icons: {
    iconfont: 'md',
  },
})
